import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CardContent, Collapse, List, ListItem, ListItemText } from "@material-ui/core";
import { CardPageItem } from "../../../custom/Page";
import Number from "../../../custom/Number";
import DarkBar from "../DarkBar";
import { FormattedMessage } from "react-intl";

const SummaryCommissionSection = ({ viewContext, commissionCurrentMonth = 0, recommendantCurrentMonth = 0, splitCurrentMonth = 0, totalReceivedCurrentMonth = 0, totalReceivedPreviousMonth = 0 }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [open, setOpen] = useState(!currentUser.hideValues);

  const hasSplitOrRecommendantValues = splitCurrentMonth > 0 || recommendantCurrentMonth > 0;
  
  const handleOpen = () => {
    if (hasSplitOrRecommendantValues) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <CardPageItem raised margin={1}>
      <DarkBar text="app.comission.lct" />
      <CardContent>
        <List>
          <ListItem button={hasSplitOrRecommendantValues} onClick={handleOpen} style={{ userSelect: "text" }} >
            <ListItemText primary={<FormattedMessage id="app.month.current" />} />
            <Number value={totalReceivedCurrentMonth} hideValue={currentUser.hideValues} currency="LCT" />
          </ListItem>
          {hasSplitOrRecommendantValues && (
            <Collapse in={open} timeout="auto" unmountOnExit>
              <ListItem>
                <ListItemText style={{ paddingLeft: 16 }} primary={<FormattedMessage id={`app.commission.directly.${viewContext}`} />} />
                <Number value={commissionCurrentMonth} hideValue={currentUser.hideValues} currency="LCT" />
              </ListItem>
              {splitCurrentMonth > 0 && (
                <ListItem>
                  <ListItemText style={{ paddingLeft: 16 }} primary={<FormattedMessage id={`app.commission.split.${viewContext}`} />} />
                  <Number value={splitCurrentMonth} hideValue={currentUser.hideValues} currency="LCT" />
                </ListItem>
              )}

              {recommendantCurrentMonth > 0 && (
                <ListItem>
                  <ListItemText style={{ paddingLeft: 16 }} primary="Recomendante" />
                  <Number value={recommendantCurrentMonth} hideValue={currentUser.hideValues} currency="LCT" />
                </ListItem>
              )}
            </Collapse>
          )}
          <ListItem>
            <ListItemText primary={<FormattedMessage id="app.month.previous" />} />
            <Number value={totalReceivedPreviousMonth} hideValue={currentUser.hideValues} currency="LCT" />
          </ListItem>
        </List>
      </CardContent>
    </CardPageItem>
  );
};

export default SummaryCommissionSection;
